import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import "../../styles/Admin-ui/Admin-PopUps.css";
import {
    IconButton,
} from '@mui/material';

import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Delete } from '@mui/icons-material';
import axios from 'axios';
import { API_DETAILS } from '../../App';
import { toast } from '../../utils/toast';
import { useSubmitGuard } from '../../utils/useSubmitGuard';
import { errorMessage } from '../../utils/errorMessage';

const AdminPopUps = ((props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [, guard] = useSubmitGuard();
    const [step, setStep] = useState(props.data.step);
    const [editCategoryName, setEditCategoryName] = useState('');

    const openPopup = () => {
        setIsOpen(true);
    };

    const closePopup = () => {
        setStep(1);
        setIsOpen(false);
        if (props.refreshData) {
            props.refreshData();
        }
    };

    const softDeleteUser = guard(async () => {
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/provider/updateProfile`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            await axios.put(url, { userId: props.data.rowData['userId'], softDelete: true }, config);
            return true;
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't delete that account. Please try again."));
            return false;
        }
    });

    const deletePrescription = guard(async () => {
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/deletePrescription/${props.data.rowData['presId']}`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.delete(url, config);
            toast.success("Medicine deleted.");
            props.data.setParentRefreshStatus(true);
            // props.data.postDeleteAction();
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't delete that medicine. Try again in a moment."));
        }
    });


    const deleteCategory = guard(async () => {
        // {presId: 2, medicineName: 'new vit', category: 'VITAMINS', diagnosis: 'Diag 103'}
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/deleteCategory/${props.data.rowData['categoryID']}`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.delete(url, config);
            toast.success("Category deleted.");
            props.data.setParentRefreshStatus(true);
            //props.data.postDeleteAction();
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't delete that category. Try again in a moment."));
        }
    });

    const deletePresType = guard(async () => {
        // {medicineId: 2, medicineName: 'new vit', category: 'VITAMINS', diagnosis: 'Diag 103'}
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/deletePresType/${props.data.rowData['presTypeId']}`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.delete(url, config);
            toast.success("Prescription type deleted.");
            //props.data.postDeleteAction();
            props.data.setParentRefreshStatus(true);
            
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't delete that prescription type. Try again in a moment."));
        }
    });

    
    const deleteDiagnosis = guard(async () => {
        // {diagId: 9, name: 'tEST DIAG', info: 'Hardcoded info for now'}
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/deleteDiagnosis/${props.data.rowData['diagId']}`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.delete(url, config);
            toast.success("Diagnosis deleted.");
            props.data.setParentRefreshStatus(true);
            // props.data.postDeleteAction();
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't delete that diagnosis. Try again in a moment."));
        }

    });
    
    const deleteNoteTemplate = guard(async () => {
    
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/deleteNoteTemplate/${props.data.rowData['diag_id']}/${props.data.rowData['type']}`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.delete(url, config);
            toast.success("Note template deleted.");
            props.data.setParentRefreshStatus(true);
            props.data.postDeleteAction();
          
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't delete that note template. Try again in a moment."));
        }
    });

    const deleteQuestionnaire = guard(async () => {
      const url =
        API_DETAILS.baseUrl +
        API_DETAILS.PORT +
        API_DETAILS.baseExtension +
        `/deleteQuestionnaire/${props.data.rowData.id}`;
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
      try {
        const res = await axios.delete(url, config);
        toast.success("Questionnaire deleted.");
        props.data.setParentRefreshStatus(true);
        props.data.setPageContextAgain("QUESTIONNAIRE");
        props.data.postDeleteAction();
      } catch (err) {
        //console.error(err);
        toast.error(
          errorMessage(err, "This questionnaire still has questions. Delete its questions first, then delete the questionnaire.")
        );
      }
    });

    const deleteQuestion = guard(async () => {
      const q_id = props.data.rowData.q_id;
  
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Content-Type": "application/json",
        },
      };
  
      const request = axios
        .delete(
          API_DETAILS.baseUrl +
            API_DETAILS.PORT +
            API_DETAILS.baseExtension +
            `/deleteQuestion/${q_id}`,
          config
        )
        .then((res) => {
          toast.success("Question deleted.");
          props.data.setParentRefreshStatus(true);
          props.data.postDeleteAction(res.data);
        })
        .catch((err) => {
          //console.error(err);
          toast.error(errorMessage(err, "We couldn't delete that question. Refresh the page and try again."));
        });
      return request;
    });
  
    const handleConfirmDelete = async () => {
        if(props.data.action === 'delete-doctor'){
            const deleted = await softDeleteUser();
            if (!deleted) {
                // Stay on the confirmation step: the error toast has said why, and
                // announcing success for a delete that did not happen is worse than
                // no dialog at all.
                return;
            }
            handleSubmit();
        }
        else if(props.data.action === 'delete-note-template'){
            deleteNoteTemplate();
            handleSubmit();
            props.refreshData();
        }
    }
    const handleSubmit = () => {
        if (props.data.action === 'delete-prescription') {

            deletePrescription();
            setIsOpen(false);
        }
        else if (props.data.action === 'delete-diagnosis') {
            deleteDiagnosis();
            setIsOpen(false);
        }
        else if (props.data.action === 'delete-doctor') {
            let temp = step == 1 ? 2 : (step == 2 ? 3 : -1);
            setStep(temp);
        }
        else if (props.data.action === 'delete-category') {

            deleteCategory();
            setIsOpen(false);
        }
        else if (props.data.action === 'delete-pres_type') {

            deletePresType();
            setIsOpen(false);
        }
        else if (props.data.action === 'delete-note-template'){
            let temp = step == 1 ? 2 : (step == 2 ? 3 : -1);
            setStep(temp);
        } 
        else if (props.data.action === "delete-questionnaire") {
          deleteQuestionnaire();
          setIsOpen(false);
        } 
        else if (props.data.action === "delete-question") {
          deleteQuestion();
          setIsOpen(false);
        }
    };

    return (
        <div>
            <IconButton color="error" onClick={openPopup} className='delete-doctor-button'>
                <Delete />
            </IconButton>


            {
                props.data.action == 'delete-doctor' && step == 1 &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Are you sure you want to delete Dr. {props.data.rowData.firstName} {props.data.rowData.lastName}?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }
            {
                props.data.action == 'delete-doctor' && step == 2 &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Confirm delete?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleConfirmDelete} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Confirm
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }
            {
                props.data.action == 'delete-doctor' && step == 3 &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={() => {
                            closePopup();     
                            props.fetchData(); 
                        }}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Delete Successful!</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={() => {
                                    closePopup();
                                    props.fetchData();
                                }} variant="outlined" style={{ marginRight: '10px' }} >
                                            Close
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                </>
            }
            {
                props.data.action == 'delete-note-template' && step == 1 &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Are you sure you want to delete Diagnosis {props.data.rowData.diagnosisName} ?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }
            {
                props.data.action == 'delete-note-template' && step == 2 &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Confirm Delete?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleConfirmDelete} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Confirm
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }
            {
                props.data.action == 'delete-note-template' && step == 3 &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Delete Successful!</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Close
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                </>
            }
            {
                props.data.action == 'delete-prescription' &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Are you sure you want to delete this prescription?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }

            {
                props.data.action == 'delete-category' &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Are you sure you want to delete this category?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }

            {
                props.data.action == 'delete-pres_type' &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%' }}>Are you sure you want to delete this prescription type?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }


            {
                props.data.action == 'delete-diagnosis' &&
                <>
                    <Popup
                        open={isOpen}
                        closeOnDocumentClick
                        onClose={closePopup}
                        modal
                    >
                        <div className="popup-content-admin">
                            <div className='row'>
                                <div className='col-12 info-col'>
                                    <h3 style={{ marginLeft: '5%'}}>Are you sure you want to delete this Diagnosis?</h3>
                                </div>
                                <div className='col-12 buttons-col row'>
                                    <div className='col-6'></div>
                                    <div className='col-6'>
                                        <Button onClick={closePopup} variant="outlined" style={{ marginRight: '10px' }} >
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} variant="contained" color="error" startIcon={<DeleteIcon />}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                                {/* <div className='col-12'></div> */}
                            </div>
                        </div>
                    </Popup>
                </>
            }
        {props.data.action == "delete-questionnaire" && (
        <>
          <Popup open={isOpen} closeOnDocumentClick onClose={closePopup} modal>
            <div className="popup-content-admin">
              <div className="row">
                <div className="col-12 info-col">
                  <h3 style={{ marginLeft: "5%" }}>
                    Are you sure you want to delete this Questionnaire?
                  </h3>
                </div>
                <div className="col-12 buttons-col row">
                  <div className="col-6"></div>
                  <div className="col-6">
                    <Button
                      onClick={closePopup}
                      variant="outlined"
                      style={{ marginRight: "10px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      color="error"
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
                {/* <div className='col-12'></div> */}
              </div>
            </div>
          </Popup>
        </>
      )}
      {props.data.action == "delete-question" && (
        <>
          <Popup open={isOpen} closeOnDocumentClick onClose={closePopup} modal>
            <div className="popup-content-admin">
              <div className="row">
                <div className="col-12 info-col">
                  <h3 style={{ marginLeft: "5%" }}>
                    Are you sure you want to delete this Question?
                  </h3>
                </div>
                <div className="col-12 buttons-col row">
                  <div className="col-6"></div>
                  <div className="col-6">
                    <Button
                      onClick={closePopup}
                      variant="outlined"
                      style={{ marginRight: "10px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      color="error"
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
                {/* <div className='col-12'></div> */}
              </div>
            </div>
          </Popup>
        </>
      )}
        </div>
    );
});

export default AdminPopUps;
